export function isAlipayBrowser(userAgent=null){
  let a = userAgent||navigator.userAgent||navigator.vendor||window.opera
  return /(alipay|aliapp)/i.test(a.toLowerCase())
}

export function isWeChatBrowser(userAgent=null){
  let a = userAgent||navigator.userAgent||navigator.vendor||window.opera
  return /micromessenger/.test(a.toLowerCase())
}

export function isAlipayHK() {
  return /alipayclienthk/.test(navigator.userAgent.toLowerCase())
}



// WEBPACK FOOTER //
// ./src/helpers/detectBrowser.js